import React from 'react';
import { Badge, Button, Table } from '@syneto/compass-react';
import Preloader from '../../../../components/preloader';
import { ACTIVATION_KEYS_SIZE_PER_PAGE_LIST } from '../../../../constants/activationKeys';
import { toActivationCodeRows } from './activationCodes';

const SupportVMActivationCodesTable = (props) => {
	const { loading, activationKeys, pagination, queryParams, onTableChange, openIncrementModal, openActivationsHistoryModal } = props;

	const renderStatus = (cell) => {
		return (
			<Badge appearance={cell === 'successful' ? 'success' : 'warning'}>{cell}</Badge>
		);
	};

	const renderActivations = (cell, row) => {
		const usedActivations = row.activations.length;
		const initialActivationNumber = row.totalActivations - row.extraActivations.length;

		return (
			<Button role="tertiary" appearance={usedActivations >= initialActivationNumber ? 'danger' : null}
				onClick={() => { openActivationsHistoryModal(row); }}
				disabled={!usedActivations}>
				{`${usedActivations} of ${row.totalActivations} Activation(s)`}
			</Button>
		);
	};

	const renderIncrementations = (cell, row) => {
		return (
			<Button role="tertiary" onClick={() => { openIncrementModal(row.productKey); }}>
				Increase Activations
			</Button>
		);
	};

	/*
	 * The table stays mounted while a page loads, so the search box keeps its text and its focus
	 * mid-typing; only the empty state shows the wait.
	 */
	const emptyTableState = () => {
		return loading ? <Preloader dataIsLoading={true} /> : 'No activation codes';
	};

	/*
	 * The pager shows the page that was asked for rather than the one the server last answered,
	 * so it moves with the click; only the total comes from the server.
	 */
	return (
		<div className="p-4 bg-white">
			<Table
				classes="vmActivationCodesTable"
				data={toActivationCodeRows(activationKeys)}
				keyField="id"
				remote
				pagination={{
					sizePerPageList: ACTIVATION_KEYS_SIZE_PER_PAGE_LIST,
					sizePerPage: queryParams.pageSize,
					showTotal: true,
					page: queryParams.page,
					totalSize: pagination?.totalItems ?? 0
				}}
				search={{ defaultSearch: queryParams.productKey }}
				onTableChange={onTableChange}
				noDataIndication={emptyTableState()}
			>
				<Table.Col field="productKey">Activation Code</Table.Col>
				<Table.Col field="createdAt">Date Issued</Table.Col>
				<Table.Col field="status" renderCell={renderStatus}>Status</Table.Col>
				<Table.Col field="activations" renderCell={renderActivations}>Activations</Table.Col>
				<Table.Col align="center" renderCell={renderIncrementations}>Action</Table.Col>
			</Table>
		</div>
	);
};

export default SupportVMActivationCodesTable;
